// ABOUTME: Axios HTTP client with JWT interceptor for authentication
// ABOUTME: Auto-attaches Authorization header, handles token refresh

import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'

// CRITICAL: Get base URL from environment
const API_BASE_URL = (import.meta as any).env.VITE_API_BASE_URL || 'http://localhost:8000'

// Create Axios instance
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: parseInt((import.meta as any).env.VITE_API_TIMEOUT || '30000'),
  headers: {
    'Content-Type': 'application/json',
  },
  // CRITICAL: Send cookies (httpOnly) with requests
  withCredentials: true,
})

// Request interceptor: Attach JWT token from localStorage (backup to cookie)
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Get token from localStorage (backup storage)
    const token = localStorage.getItem('access_token')

    // CRITICAL: Attach Authorization header if token exists
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

// Response interceptor: Handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Handle 401 Unauthorized → redirect to login
    if (error.response?.status === 401) {
      // Clear tokens
      localStorage.removeItem('access_token')

      // Redirect to login (will be handled by auth context)
      window.dispatchEvent(new CustomEvent('auth:unauthorized'))
    }

    return Promise.reject(error)
  }
)
